import { EIsinRegistraceSouborTyp } from 'services/akcionar/emise/isinUpload';

const typPrilohyRegistraceSelect = [
    {
        value: EIsinRegistraceSouborTyp.VYPISOR,
        labelcz: 'ISIN_REGISTRACE_SOUBOR_VYPISOR'
    },
    {
        value: EIsinRegistraceSouborTyp.EMISNIPODMINKY,
        labelcz: 'ISIN_REGISTRACE_SOUBOR_EMISNIPODMINKY'
    },
    {
        value: EIsinRegistraceSouborTyp.POTVRZENIISIN,
        labelcz: 'ISIN_REGISTRACE_SOUBOR_POTVRZENIISIN'
    },
    {
        value: EIsinRegistraceSouborTyp.JINY,
        labelcz: 'ISIN_REGISTRACE_SOUBOR_JINY'
    }
];

export default typPrilohyRegistraceSelect;
